import pluralize from 'pluralize';

type PosieItems = 'NEW_POI' | 'NEW_CUSTOM_POI' | 'NEW_MARKET';
type PosieConfig = Record<PosieItems, number>;

const POSIE_ROTATION_RATIO_IN_DAYS: PosieConfig = {
    NEW_POI: 2,
    NEW_CUSTOM_POI: 7,
    NEW_MARKET: 7,
};

const POSIE_MAX_HISTORY_IN_YEARS: PosieConfig = {
    NEW_POI: 7,
    NEW_CUSTOM_POI: 7,
    NEW_MARKET: 1,
};

export const getPosieMaxHistoryByRange = ({
    type,
    range = 'month',
    withSuffix = true,
}: {
    type: PosieItems;
    range: 'day' | 'year' | 'month';
    withSuffix?: boolean;
}) => {
    const item = POSIE_MAX_HISTORY_IN_YEARS[type];

    let formattedItem = item;

    if (range === 'month') formattedItem = item * 12;
    if (range === 'day') formattedItem = item * 365;

    const rangeLabel = pluralize(range, formattedItem);

    return withSuffix ? `${formattedItem} ${rangeLabel}` : `${formattedItem}`;
};

export const getPosieRotationRatioByRange = ({
    type,
    range = 'day',
    withSuffix = true,
}: {
    type: PosieItems;
    range: 'day' | 'hour';
    withSuffix?: boolean;
}) => {
    const item = POSIE_ROTATION_RATIO_IN_DAYS[type];

    let formattedItem = item;

    if (range === 'hour') formattedItem = item * 24;

    const rangeLabel = pluralize(range, formattedItem);

    return withSuffix ? `${formattedItem} ${rangeLabel}` : `${formattedItem}`;
};
